export default "__VITE_ASSET__BR1eWuo6__"